function XmasController(){
	this.className			= "XmasController";
	this.glob				= "/**";
	this.priority			= 999;

	this.iconScale			= 1;
	this.iconScaling		= "default"; //"squareroot"

	this.locations = [
		{
			name: "san-diego",
			title: "San Diego",
			message: "Message from San Diego",
			location: "us",
			icon: "snowflake",
			x: 16,
			y: 38.5,
			front: "/assets/xmas/2020/images/postcards/San-Diego.jpg",
			back: "/assets/xmas/2020/images/postcards/San-Diego2.jpg",
			skip: false,
		},{
			name: "denver",
			title: "Denver",
			message: "Message from Denver",
			location: "us",
			icon: "bell",
			x: 19,
			y: 35,
			front: "/assets/xmas/2020/images/postcards/Denver.jpg?r2",
			back: "/assets/xmas/2020/images/postcards/Denver2.jpg",
			skip: false,
		},{
			name: "boston",
			title: "Boston",
			message: "Message from Boston",
			location: "us",
			icon: "snowflake",
			x: 28.3,
			y: 31.8,
			front: "/assets/xmas/2020/images/postcards/Boston.jpg",
			back: "/assets/xmas/2020/images/postcards/Boston2.jpg",
			skip: false,
		},{
			name: "uk",
			title: 'UK',
			message: "Explore and Zoom",
			location: 'uk',
			icon: "zoom",
			x: 45.6,
			y: 25,
			front: "/assets/xmas/2020/images/postcards/London.jpg",
			back: "/assets/xmas/2020/images/postcards/London2.jpg",
			skip: true,
		},{
			name: "belfast",
			title: "Belfast",
			message: "Message from Belfast",
			location: "uk",
			icon: "bell",
			x: 45.6,
			y: 25,
			front: "/assets/xmas/2020/images/postcards/Belfast.jpg?r2",
			back: "/assets/xmas/2020/images/postcards/Belfast2.jpg",
			skip: false,
		},{
			name: "porthtowan",
			title: "Porthtowan",
			message: "Message from Porthtowan",
			location: "uk",
			icon: "candycane",
			x: 45.8,
			y: 27.3,
			front: "/assets/xmas/2020/images/postcards/Cornwall.jpg",
			back: "/assets/xmas/2020/images/postcards/Cornwall2.jpg",
			skip: false,
		},{
			name: "cardiff",
			title: "Cardiff",
			message: "Message from Cardiff",
			location: "uk",
			icon: "bell",
			x: 46.4,
			y: 26.5,
			front: "/assets/xmas/2020/images/postcards/Cardiff.jpg",
			back: "/assets/xmas/2020/images/postcards/Cardiff2.jpg",
			skip: false,
		},{
			name: "bath",
			title: "Bath",
			message: "Message from Bath",
			location: "uk",
			icon: "candle",
			x: 46.7,
			y: 26.5,
			front: "/assets/xmas/2020/images/postcards/Bath.jpg",
			back: "/assets/xmas/2020/images/postcards/Bath2.jpg",
			skip: false,
		},{
			name: "leeds",
			title: "Leeds",
			message: "Message from Leeds",
			location: "uk",
			icon: "snowflake",
			x: 46.7,
			y: 25.3,
			front: "/assets/xmas/2020/images/postcards/Harrogate.jpg",
			back: "/assets/xmas/2020/images/postcards/Harrogate2.jpg",
			skip: false,
		},{
			name: "london",
			title: "London",
			message: "Message from London",
			location: "uk",
			icon: "candycane",
			x: 47.2,
			y: 26.2,
			front: "/assets/xmas/2020/images/postcards/London.jpg",
			back: "/assets/xmas/2020/images/postcards/London2.jpg",
			skip: false,
		},{
			name: "dusseldorf",
			title: "Dusseldorf",
			message: "Message from Dusseldorf",
			location: "de",
			icon: "snowflake",
			x: 49,
			y: 27.5,
			front: "/assets/xmas/2020/images/postcards/Dusseldorf.jpg",
			back: "/assets/xmas/2020/images/postcards/Dusseldorf2.jpg",
			skip: false,
		},{
			name: "doha",
			title: "Doha",
			message: "Message from Doha",
			location: "qa",
			icon: "candle",
			x: 61.1,
			y: 43,
			front: "/assets/xmas/2020/images/postcards/Doha.jpg",
			back: "/assets/xmas/2020/images/postcards/Doha2.jpg",
			skip: false,
		},{
			name: "sydney",
			title: "Sydney",
			message: "Message from Sydney",
			icon: "bell",
			x: 87.8,
			y: 79.9,
			front: "/assets/xmas/2020/images/postcards/Sydney.jpg",
			back: "/assets/xmas/2020/images/postcards/Sydney2.jpg",
			skip: false,
		},{
			name: "auckland",
			title: "Auckland",
			message: "Message from Auckland",
			icon: "candle",
			x: 94.2,
			y: 82.5,
			front: "/assets/xmas/2020/images/postcards/Auckland.jpg",
			back: "/assets/xmas/2020/images/postcards/Auckland2.jpg",
			skip: false,
		},
	];


	const oldMapHeight = 430.6;
	const newMapHeight  = 630.6;
	const scaleChange = newMapHeight/oldMapHeight;
	const yChange = (newMapHeight-oldMapHeight)/2;

	this.locations.forEach(location => {
		location.y = location.y / scaleChange + (yChange/newMapHeight) * 100;
	});
};
XmasController.inheritsFrom( StandardController );
XmasController.prototype.swap = function(){
	this.$body			= $("body");	// what to scroll when navigating with aviator
	this.$page			= this.$body.find('.js-page');	// what to scroll when navigating with aviator

	this.setupMap();

	this.locations.forEach(location => {
		Preloader.add(location.front,false,{priority:3});
		Preloader.add(location.back,false,{priority:4});
	});

	return true;
}
XmasController.prototype.on = function(){
	return true;
};
XmasController.prototype.setupMap = function(){
	this.$map			= this.$page.find('.js-map');	// what to scroll when navigating with aviator
	this.$uk 			= this.$map.find(".js-uk");
	this.$world 		= this.$map.find(".js-world");
	this.$mapWrapper 	= this.$map.parents(".js-map-wrapper");
	this.$zoomOut 		= this.$mapWrapper.find('.js-zoom-out');

	this.map 			= this.$map[0];


	const $map 		= this.$map;
	const map 		= this.map;
	const parent 	= map.parentElement


	this.$zoomOut.on('click', (e) => {
		e.preventDefault();
		this.zoomToWorld();
	});


	const panzoom = Panzoom(map, {contain: 'outside', maxScale:10}); //startScale: 0// ,
	parent.addEventListener('wheel', panzoom.zoomWithWheel)


	this.panzoom = panzoom;
	this.lastChange = {x:0,y:0};
	this.lastPosition = this.lastChange;

	//Perhaps have dot triggers as well?
	this.locations.forEach(location => {
		const locationClass = location.icon === "zoom" ? `location-${location.location}-zoom` : `location-${location.location}`;
		const $dot = $("<div/>")
			.attr("class",`location ${locationClass}`)
			.css("left",`calc(${location.x}%`)
			.css("top",`calc(${location.y}%`);

		const $inner = $dot.append("<div/>").children(":first")
			.attr("class",`location-inner icon-${location.icon}`);

		if(location.message){
			$inner.append(`<span class='label'>${location.message}</span>`);
		}

		$map.append($dot);

		$dot.on("click",() => this.selectLocation(location.name));

		location.$dot = $dot;
		location.$inner = $inner;
	});
	this.updateTransforms();

	map.addEventListener('panzoomzoom', (e) => {
		this.$ukLocation 	= this.$map.find('.location-uk');
		this.$ukZoomIn 		= this.$map.find('.location-uk-zoom');

		if(e.detail.scale > 6){
			this.$ukZoomIn.hide();
			this.$zoomOut.show();
			this.$ukLocation.show();
		}else{
			this.$zoomOut.hide();
			this.$ukLocation.hide();
			this.$ukZoomIn.show();
		}

		this.updateTransforms(e.detail.scale);
		this.zoomEndEvent();
	});

	map.addEventListener('panzoomend', (e) => {
		this.zoomEndEvent();
	});


	//Reset needs to wait for it to be ready. Shouldn't matter about image loading though as we've set the size explicitly.
	setTimeout(() => {

		const originalWidth = 1000;
		const originalHeight = 631;
		const w = this.$map.parent().width();
		const h = this.$map.parent().height();

		const x = (w-originalWidth)/2/panzoom.getOptions().minScale;
		const y = (h-originalHeight)/2/panzoom.getOptions().minScale;

		this.lastPosition = {x,y};
		panzoom.zoom(panzoom.getOptions().minScale,{animation:false});

		// Urgh, then we need to wait for it to have finish zooming. Still seems to take time even with animation false.
		// Could hook into events and then cancel, but going simple and dirty instead. It is Christmas after all.
		setTimeout(() => {
			panzoom.pan(x, y);
			this.$map.css("visibility","visible"); //TODO - this might not be where we want to show the whole site. Will have to see.

			this.initialPan = panzoom.getPan();
			this.initialZoom = panzoom.getScale();

			this.zoomEndEvent();

		},100);

	},0)

}
XmasController.prototype.selectLocation = function(name){

	if(!this.lastChange || this.lastChange.d < 3){

		// @TOM I made the cornwall icon toggle it currently.
		// But really just need to trigger this.zoomToWorld() and this.zoomToUK(); seperately from our buttons.
		if(name == "uk"){
			if(this.panzoom.getScale() > 6){
				this.zoomToWorld();
			}else{
				this.zoomToUK();
			}

		}else{
			this.showPostcard(name)
		}


	}else{
		console.log("Ignore click, we think it was a pan");
	}
}
XmasController.prototype.updateTransforms = function(scale = 1){
	this.locations.forEach(location => {
		let m = 1;
		if(this.iconScaling == "default") m = 1 / scale;
		else if(this.iconScaling == "squareroot") m = 1 / Math.sqrt(scale);

		const offset = 12.5 * m;
		location.$dot.css("transform",`translate(-${offset}px,-${offset}px) scale(${this.iconScale * m})`);
	});
}
XmasController.prototype.zoomEndEvent = function(){

	const t = performance.now();
	const pan = this.panzoom.getPan();
	const scale = this.panzoom.getScale();

	this.lastChange = {x: this.lastPosition.x - pan.x, y: this.lastPosition.y - pan.y, t:t };
	this.lastChange.d = Math.sqrt(this.lastChange.x*this.lastChange.x + this.lastChange.y*this.lastChange.y);

	this.lastPosition = Object.assign({},pan,{time:t, scale:scale});

}
XmasController.prototype.zoomTo$element = function(zoom, $element){
	//Note - haven't bothered with centres
	const offset = $element.offset();
	if(offset.left || offset.top){
		this.panzoom.zoomToPoint(zoom, { clientX: offset.left, clientY: offset.top });
		//this.zoomEndEvent();
	}

}
XmasController.prototype.zoomToUK = function(){
	return this.zoomTo$element(10,this.$uk);
}
XmasController.prototype.zoomToWorld = function(zoom){
	return this.zoomTo$element(zoom ?? 1, this.$world); //this.initialZoom ? this.initialZoom :
}
XmasController.prototype.showPostcard = function(name){

	const location = this.locations.find(location => location.name == name);

	Preloader.add(location.front,false,{priority:1});
	Preloader.add(location.back,false,{priority:2});

	new Postcard({
		items: this.locations,
		item: location,
	});
};
